import colors from '../../../../constants/appColors'
import { getContrastTextColor } from '../../../../utils/colorContrast'
import {
  DELTA_PALETTES,
  RESULT_PALETTES,
  SERIES_PALETTES,
} from '../constants/colors'
import type { ColorSurface, DeltaTone, GameOutcome } from '../types'

export interface ChipColors {
  fill: string
  content: string
}

/** The line colour of a stat's colour slot (`StatsSelection.colorSlots`). */
export const getSeriesColor = (slot: number, surface: ColorSurface): string =>
  SERIES_PALETTES[surface][slot]

const BLACK_TEXT = '#000000'

/**
 * Fill and text of a selected stat chip, matching its line: dark text or
 * white, whichever reads better on the fill (the palettes hold no tenant
 * primary, so `PRIMARY_BUTTON_CONTENT` never applies).
 */
export const getSeriesChipColors = (
  slot: number,
  surface: ColorSurface
): ChipColors => {
  const fill = getSeriesColor(slot, surface)
  return {
    fill,
    content:
      getContrastTextColor(fill) === BLACK_TEXT
        ? colors.SECONDARY_500
        : colors.WHITE,
  }
}

/** Result text colour; a tie or unknown result reads neutral. */
export const getResultColor = (
  outcome: GameOutcome | null,
  surface: ColorSurface
): string => RESULT_PALETTES[surface][outcome ?? 'T']

/** Comparison delta colour: green better, red worse. */
export const getDeltaColor = (tone: DeltaTone, surface: ColorSurface): string =>
  DELTA_PALETTES[surface][tone]
